import React from 'react';
import { Link } from 'react-router-dom';
import { add, formatDate } from 'src/lib/time';
import { isNotStarted, isInProgress, isCompleted } from 'src/lib/job';
import './style.scss';

const getTaskColor = (task) => {
  return (
    (isNotStarted(task) && '#fc464a') ||
    (isInProgress(task) && '#3cb6e3') ||
    (isCompleted(task) && '#9aca27')
  );
};

class Slider extends React.Component {
  render() {
    const { disabled, scale, task, onChange } = this.props;
    const total = scale.end - scale.start;
    const ogLeft = `${((task.original.start - scale.start) / total) * 100}%`;
    const ogRight = `${((scale.end - task.original.end) / total) * 100}%`;
    const left = `${((task.adjusted.start - scale.start) / total) * 100}%`;
    const right = `${((scale.end - task.adjusted.end) / total) * 100}%`;
    return (
      <div>
        <p className="mb-0 ml-3 mb-3" style={{ lineHeight: 1 }}>
          {task.label}
        </p>
        <div className="slider-container">
          <div className="slider">
            {/* <div className="inverse-left" style={{ width: 70 }} />
          <div className="inverse-right" style={{ width: 70 }} /> */}
            <div
              className="range"
              style={{ left, right, backgroundColor: getTaskColor(task) }}
            />
            <div
              className="range"
              style={{
                left: ogLeft,
                right: ogRight,
                backgroundColor: getTaskColor(task),
                opacity: 0.3,
                marginTop: -7
              }}
            />
            {(isInProgress(task) || isCompleted(task)) && !disabled && (
              <span className="thumb thumb-left" style={{ left }} />
            )}
            <div className="sign sign-left" style={{ left }}>
              <span>{formatDate(task.adjusted.start, 'time')}</span>
            </div>
            {isCompleted(task) && !disabled && (
              <span className="thumb thumb-right" style={{ right }} />
            )}
            <div className="sign sign-right" style={{ right }}>
              <span>{formatDate(task.adjusted.end, 'time')}</span>
            </div>
          </div>
          {(isInProgress(task) || isCompleted(task)) && !disabled && (
            <input
              type="range"
              tabIndex="0"
              value={task.adjusted.start}
              max={scale.end}
              min={scale.start}
              step={60000}
              onChange={(event) =>
                onChange(task, event.target.value, 'start_time')
              }
            />
          )}
          {isCompleted(task) && !disabled && (
            <input
              type="range"
              tabIndex="0"
              value={task.adjusted.end}
              max={scale.end}
              min={scale.start}
              step={60000}
              onChange={(event) =>
                onChange(task, event.target.value, 'end_time')
              }
            />
          )}
        </div>
      </div>
    );
  }
}

export default class Timeline extends React.Component {
  makeSections = () => {
    const { scale } = this.props;
    const multiplier = this.props.multiplier || Math.ceil(scale.total / 14);
    const Sections = [];
    for (let hour = 0; hour <= scale.total / multiplier; hour++) {
      Sections.push(
        <section key={hour}>
          {formatDate(add(scale.start, hour * multiplier, 'hours'), 'h a')}
        </section>
      );
    }
    return Sections;
  };

  makeSliders = () => {
    const { tasks, scale, disabled } = this.props;
    return tasks.map((task, index) => {
      if (task.link) {
        return (
          <section key={index}>
            <Link
              to={task.link}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <Slider
                task={task}
                scale={scale}
                disabled={disabled}
                onChange={this.handleChange}
              />
            </Link>
          </section>
        );
      } else {
        return (
          <section key={index}>
            <Slider
              task={task}
              scale={scale}
              disabled={disabled}
              onChange={this.handleChange}
            />
          </section>
        );
      }
    });
  };

  handleChange = (task, value, type) => {
    if (this.props.onChange) {
      this.props.onChange(task, new Date(Number(value)), type);
    }
  };

  render() {
    const Sections = this.makeSections();
    const Sliders = this.makeSliders();

    return (
      <div className="timeline">
        <div className="scale">{Sections}</div>
        <div className="data">{Sliders}</div>
      </div>
    );
  }
}
